<template>
	<div id="app">
		<!-- <router-view /> -->
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
	</div>
</template>
<script>

import store from '@/store'
import jssdk from '@/jssdk'

export default {
	name: '',
	data() {
		return {

		}
	},
	watch: {
		// 监听路由对象变化
		'$route': {
			handler(to, from) {
				// 当路由发生变化时，更新当前路径,分享
				console.log(23, "watch---to:", to.name == 'home' ? '/' : to.fullPath)
				console.log(156, 'location', location.href.split('#')[0])
				console.log(29, /(Android)/i.test(navigator.userAgent))
				console.log(30, navigator.userAgent)
				if (/(Android)/i.test(navigator.userAgent)) {
					console.log(32, store.state.appId, store.state.appType)
					jssdk.getWXConfig({
						appId: store.state.appId,
						appType: store.state.appType,
					})
				}
				// window.wx.miniProgram.postMessage({
				// 	data: {
				// 		path: to.name == 'home' ? '/' : to.fullPath,
				// 		title: document.title || '邀请你加入【及象兴趣社区】，参与互动，分享兴趣爱好……',
				// 		imageUrl: 'https://ggpt.sunlands.com/saas-community/share.png'
				// 	}
				// })
			},
			// 设置为深度监听
			deep: true
		}
	},
	mounted() {

	}
}
</script>
<style lang="scss">
* {
	margin: 0;
	padding: 0;
}

.el-message {
	min-width: 200px
}

.el-popover {
	min-width: 20px !important;
}

#app {
	-webkit-touch-callout: none;
	/* iOS Safari */
	-webkit-user-select: none;
	/* Safari */
	-khtml-user-select: none;
	/* Konqueror HTML */
	-moz-user-select: none;
	/* Firefox */
	-ms-user-select: none;
	/* Internet Explorer/Edge */
	user-select: none;
	/* Non-prefixed version, currently supported by Chrome and Opera */
}
</style>



// WEBPACK FOOTER //
// src/App.vue